var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplianceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.013,6.817h-.576A2.063,2.063,0,0,0,25.4,5.078H10.622A2.067,2.067,0,0,0,8.556,7.143v9.041a6.347,6.347,0,0,1-1.564.2H5.839a.762.762,0,0,0-.761.761v5.59a7.375,7.375,0,0,0,6.288,7.329.8.8,0,0,0,.25,0,7.605,7.605,0,0,0,.778-.166,2.071,2.071,0,0,0,.836.18H28.013a2.067,2.067,0,0,0,2.065-2.065V8.882a2.067,2.067,0,0,0-2.065-2.065Zm-18.8.326A1.414,1.414,0,0,1,10.622,5.73H25.4a1.414,1.414,0,0,1,1.372,1.087H13.23a2.067,2.067,0,0,0-2.065,2.065v5.985a.7.7,0,0,0-.161.091,6.347,6.347,0,0,1-1.8,1.021Zm2.309,22.275a.21.21,0,0,1-.052,0A6.726,6.726,0,0,1,5.73,22.734v-5.59a.109.109,0,0,1,.109-.109H6.992a7.04,7.04,0,0,0,4.423-1.57.116.116,0,0,1,.152,0,7.035,7.035,0,0,0,4.423,1.57h1.153a.109.109,0,0,1,.109.109v5.59a6.726,6.726,0,0,1-5.735,6.685Zm17.909-1.405a1.414,1.414,0,0,1-1.413,1.413H13.686a7.343,7.343,0,0,0,3.908-4.565h9.549a.326.326,0,1,0,0-.652H17.754a7.576,7.576,0,0,0,.149-1.475v-.482h9.239a.326.326,0,1,0,0-.652H17.9V19.644h9.239a.326.326,0,0,0,0-.652H17.9V17.143a.762.762,0,0,0-.761-.761H15.989a6.378,6.378,0,0,1-4.011-1.424.848.848,0,0,0-.161-.091V8.882A1.414,1.414,0,0,1,13.23,7.469H28.013a1.414,1.414,0,0,1,1.413,1.413Zm-3.7-14.783a.326.326,0,0,1-.326.326H15.839a.326.326,0,0,1,0-.652H25.4A.326.326,0,0,1,25.731,13.23Zm-8.478-2.609a.326.326,0,0,1,.326-.326h6.087a.326.326,0,0,1,0,.652H17.578A.326.326,0,0,1,17.252,10.622ZM14.8,20a.326.326,0,0,1,0,.461l-3.633,3.633a.761.761,0,0,1-1.076,0l-1.84-1.84a.326.326,0,0,1,.461-.461l1.84,1.84a.091.091,0,0,0,.153,0L14.342,20a.326.326,0,0,1,.461,0Z",
    transform: "translate(-5.078 -5.078)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceIcon);
export default __webpack_public_path__ + "static/media/compliance-icon.5d580b3cd18e25fbd42ce318c27a4107.svg";
export { ForwardRef as ReactComponent };